import { PanelContent, PanelContentBaseComponent } from '@addins/core/panel';
import { ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { UnitActivity } from '@models/imported/SagaSchema/UnitActivity';
import { ListResourceStatus } from '@models/imported/SagaStateLib/ListResourceStatus';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { StatusChangeRequirementsService } from '../../services/status-change-requirements/status-change-requirements.service';
import { StatusListService } from '../../services/status-list/status-list.service';

@Component({
  selector: 'app-status-list',
  templateUrl: './status-list.component.html',
  styleUrls: ['./status-list.component.scss'],
  providers: [StatusListService]
})
export class StatusListComponent extends PanelContentBaseComponent implements OnInit, OnDestroy, PanelContent {
  @HostBinding('class.left-border')
  @Input()
  leftBorder: boolean;

  get myUnit(): UnitActivity {
    return this.statusListService.myUnit;
  }

  protected _sub: Subscription = null;

  get statuses(): ListResourceStatus[] {
    return this.statusListService.mobileStatuses;
  }

  constructor(
    protected statusListService: StatusListService,
    protected statusChangeRequirementsService: StatusChangeRequirementsService,
    protected changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  change(status: ListResourceStatus) {
    this.statusChangeRequirementsService.getRequestParameter(status).then(
      requestParameter => this.statusListService.change(status, requestParameter),
      err => err
    );
  }

  ngOnInit() {
    this._sub = this.statusListService.$ready.pipe(filter(isReady => isReady)).subscribe(() => this.onInit());
    if (this.myUnit !== null) {
      this.clean();
    }
  }

  ngOnDestroy() {
    this.clean();
  }

  protected onInit() {
    this.clean();
    this.changeDetectorRef.detectChanges();
  }

  private clean() {
    if (this._sub !== null) {
      this._sub.unsubscribe();
      this._sub = null;
    }
  }
}
